import { loadPatientsRouterConfig } from './LoadPatients/routerConfig';
import { newWorklistRouterConfig } from './NewWorklist/routerConfig';
import { patientBulkUpdateRouterConfig } from './PatientBulkUpdate/routerConfig';
import { patientDatabaseRouterConfig } from './PatientDatabase/routerConfig';

export const preScreenRouterConfig = [
  loadPatientsRouterConfig,
  patientBulkUpdateRouterConfig,
  patientDatabaseRouterConfig,
  newWorklistRouterConfig
];
